<div class="row mb-1">
  <div class="col-md-12">
    Controle Associado
    <ng-select [disabled]="visualizar" id="selectRiscoIdentificado" (change)="changeControle()"
      [(ngModel)]="associadoSelecionado">
      <ng-option [value]="obj.controle" *ngFor="let obj of objPrincipal.associados">{{ obj.descricao }}</ng-option>
    </ng-select>
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Risco Vinculado
    <input type="text" [disabled]="true" id="txtRiscoVinculado" class="form-control form-control-sm"
      [(ngModel)]="txtRiscoVinculado" maxlength="255" />
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    Prioridade
    <input type="text" [disabled]="true" id="txtPrioridade" class="form-control form-control-sm"
      [(ngModel)]="txtPrioridade" maxlength="200" />
  </div>
</div>
<div class="row mb-1">
  <div class="col-md-12">
    Tipo de Teste
    <input type="text" [disabled]="true" id="txtTipoTeste" class="form-control form-control-sm"
      [(ngModel)]="txtTipoTeste" maxlength="200" />
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-3">
    Serão realizados testes?
    <ng-select [disabled]="visualizar" id="selectRealizarTestes" (change)="changeRealizarTestes()"
      [(ngModel)]="realizarTestes">
      <ng-option [value]="true">Sim</ng-option>
      <ng-option [value]="false">Não</ng-option>
    </ng-select>
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        Questões/Subquestão

        <div class="row mb-2" *ngIf="realizarTestes === false">
          <div class="col-md-12">
            <input type="text" [disabled]="true" class="form-control form-control-sm" [value]="MENSAGEM_SEM_TESTE" />
          </div>
        </div>

        <div class="row mb-2" *ngIf="realizarTestes !== false">
          <div class="col-md-11">
            <ng-select [disabled]="visualizar" id="selectQuestao" [(ngModel)]="questaoSelecionada">
              <ng-option [value]="obj.id" *ngFor="let obj of listQuestoesGeral">{{obj.ordem}} - {{ obj.nome
                }}</ng-option>
            </ng-select>
          </div>
          <div class="col-md-1">
            <button *ngIf="!visualizar" class="icon-btn btn btn-primary btn-xs text-left" (click)="addQuestao()">
              <i class="far fas fa-plus fa-sm"></i>
            </button>
          </div>
        </div>

        <ng-container *ngIf="realizarTestes !== false">
          <div class="row mb-1" *ngFor="let item of listQuestoes">
            <div class="col-md-11">
              <input type="text" [disabled]="true" id="txtCausa" class="form-control form-control-sm"
                [(ngModel)]="item.descricaoQuestao" maxlength="555" />
            </div>
            <div class="col-md-1">
              <button *ngIf="!visualizar" class="icon-btn btn btn-danger btn-xs text-left"
                (click)="removeQuestao(item)">
                <i class="far fas fa-trash fa-sm"></i>
              </button>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>
<div class="row mb-1" *ngIf="realizarTestes === false">
  <div class="col-md-12">
    Justificativa
    <textarea
      [disabled]="visualizar"
      id="txtJustificativa" class="form-control form-control-sm"
      rows="3"
      [(ngModel)]="txtJustificativa" maxlength="500"></textarea>
  </div>
</div>
<div class="row mb-2" *ngIf="!visualizar">
  <div class="col-md-8"></div>
  <div class="col-md-4" style="text-align: right;">
    <button type="button" class="btn btn-primary btn-sm" (click)="novo()">
      <i class="fas fa-file"></i> Novo
    </button>
    &nbsp;
    <button type="button" class="btn btn-success btn-sm" (click)="adicionar()">
      <i class="fas fa-plus"></i> {{ getNameBtn() }}
    </button>
  </div>
</div>

<div class="row mb-1">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h4>Lista de Testes</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-grid-abas-matriz-risco [dados]="objPrincipal.testes" [listColunas]="listColunas" [siglaPosicao]="'T'"
          [visualizar]="this.visualizar" (btnRemover)="remover($event)"
          (btnEditar)="editar($event)"></app-grid-abas-matriz-risco>
      </div>
    </div>
  </div>
</div>